'use client';
import React, { useState } from 'react';
import '../../app/KailashBanner.css';
import Itinerary from './VietnamItineraryAccordion';


export default function KailashBanner() {
  const [showItinerary, setShowItinerary] = useState(false);

  const toggleItinerary = () => {
    setShowItinerary(!showItinerary);
  };

  return (
    <div className="kailash-banner">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-10">
            <p className="lead text-muted mb-4 text-center">
              Planning a memorable international holiday? Our Vietnam tour package from Bangalore is designed for travellers who want a perfect mix of culture, nature, history, food, shopping, and adventure. Whether you are looking for a family vacation, honeymoon, couple trip, group tour, or a customized holiday, Vietnam is one of the best destinations for Indian travellers.
            </p>
            <p className="lead text-muted mb-4 text-center">
              With our carefully planned Vietnam travel package, you can explore beautiful cities like Hanoi, Ho Chi Minh City, Da Nang, Hoi An, Halong Bay, Ninh Binh, and Phu Quoc. From scenic cruises and ancient towns to beaches, temples, caves, nightlife, and delicious Vietnamese cuisine, every day of your trip is filled with unforgettable experiences.
            </p>
            <p className="lead text-muted mb-4 text-center">
              Choose from our best Vietnam holiday packages from India and enjoy a smooth travel experience with hotel stays, sightseeing, airport transfers, visa assistance, and optional flights.
            </p>
            
          </div>
        </div>
      </div>

      {/* Itinerary Modal/Popup */}
      {showItinerary && (
        <div style={{
                    // marginTop:'20px',
                  }} className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center z-3">
  <div className="bg-white rounded shadow w-100 w-md-75 w-lg-50 h-100 h-md-auto overflow-auto">
    
    <div className="d-flex justify-content-end border-bottom p-3">
      <button 
        className="btn-close" 
        aria-label="Close" 
        onClick={toggleItinerary}
      ></button>
    </div>
    
    <div className="p-3">
      <Itinerary/>
    </div>
    
  </div>
</div>

      )}
    </div>
  );
}